import React, { createContext, useContext, useState, useEffect } from 'react';

// Translation data
const translations = {
  tr: {
    // Navigation
    'nav.home': 'Ana Sayfa',
    'nav.tours': 'Turlar',
    'nav.istanbul': 'İstanbul Turları',
    'nav.domestic': 'Yurtiçi Turlar',
    'nav.international': 'Yurtdışı Turlar',
    'nav.all_tours': 'Tüm Turları Gör',
    'nav.blog': 'İstanbul Hikâyeleri',
    'nav.about': 'Hakkımızda',
    'nav.contact': 'İletişim',
    'nav.admin': 'Yönetim',
    
    // Homepage
    'home.hero_title': 'İstanbul\'u Keşfedin',
    'home.hero_subtitle': 'Profesyonel rehberlerimizle tarihi yarımadanın büyüsünü yaşayın',
    'home.featured_tours': 'Öne Çıkan Turlar',
    'home.featured_subtitle': 'En popüler ve beğenilen turlarımızla İstanbul\'un büyüsünü yaşayın',
    'home.upcoming_tours': 'Yaklaşan Turlar',
    'home.view_all': 'Tümünü Gör',
    'home.calendar_title': 'Tur Takvimi',
    'home.calendar_subtitle': 'Uygun tarihlerde yerinizi ayırtın',
    'home.no_tours_this_month': 'Bu ay için planlanmış tur bulunmamaktadır.',
    'home.check_calendar': 'Takvimden diğer ayları kontrol edebilirsiniz.',
    'tour.info_request': "Yeni tarih için bilgi iste",
    'home.istanbul_calendar': "İstanbul Turları Takvimi",
    'home.upcoming_istanbul': "Yaklaşan İstanbul Turları",
    'tour.dates_section': "Tur Tarihleri",
    'tour.next_date': 'EN YAKIN TUR',
    'tour.dates_soon': 'Yeni tarihler yakında',
    'tour.upcoming_dates': 'Yaklaşan Tur Tarihleri',
    'tour.available': 'Müsait',
    'tour.limited': 'Son Kontenjan',
    'tour.full': 'Dolu',
    'tour.related': 'Bunları da Beğenebilirsiniz',
    'tour.no_open_dates': 'Bu tur için şu an rezervasyona açık tarih yok. Yeni tarihler yakında eklenecek.',
    'tour.pick_date_hint': 'Tarih seçmek için listeden veya takvimden rezervasyona açık bir gün seçin.',
    'tour.seats_left': 'kişilik yer kaldı',
    'tour.selected_date': 'Seçilen tarih',
    'home.day_tours': 'Bu günün turları',
    'home.calendar_heading': 'Tur Takvimi',
    'home.calendar_desc': 'Yaklaşan turları görüntüleyin ve hemen rezervasyon yapın',
    'home.book': 'Rezervasyon',
    'home.view_all_tours': 'Tüm Turları Gör',
    'home.month_calendar': 'tur takvimi',
    
    // Tours
    'tours.per_person': '/kişi',
    'tours.duration': 'Süre',
    'tours.capacity': 'Kapasite',
    'tours.meeting_point': 'Buluşma Noktası',
    'tours.included': 'Dahil Olanlar',
    'tours.excluded': 'Dahil Olmayanlar',
    'tours.program': 'Tur Programı',
    'tours.book_now': 'Rezervasyon Yap',
    'tours.whatsapp': 'WhatsApp ile Sor',
    'tours.day': 'Gün',
    
    // Booking Form
    'booking.title': 'Rezervasyon Formu',
    'booking.first_name': 'Ad',
    'booking.last_name': 'Soyad',
    'booking.tc_number': 'TC Kimlik No',
    'booking.birth_date': 'Doğum Tarihi',
    'booking.email': 'E-posta',
    'booking.phone': 'Telefon',
    'booking.guests': 'Kişi Sayısı',
    'booking.date': 'Tarih Seçiniz',
    'booking.payment_method': 'Ödeme Yöntemi',
    'booking.credit_card': 'Kredi Kartı',
    'booking.bank_transfer': 'Havale / EFT',
    'booking.cash_on_tour': 'Tur Esnasında Ödeme',
    'booking.special_requests': 'Özel İstekler',
    'booking.submit': 'Rezervasyon Yap',
    'booking.total': 'Toplam',
    
    // Contact
    'contact.title': 'İletişim',
    'contact.subtitle': 'Bizimle iletişime geçin',
    'contact.working_hours': 'Çalışma Saatleri',
    'contact.weekdays': 'Hafta içi (Pzt-Cum)',
    'contact.weekend': 'Hafta sonu',
    'contact.closed': 'Kapalı',
    'contact.send': 'Gönder',
    
    // About
    'about.title': 'Hakkımızda',
    'about.who_we_are': 'Biz Kimiz?',
    
    // Footer
    'footer.rights': 'Tüm Hakları Saklıdır',
    'footer.tursab': 'TÜRSAB Üyesi',
    
    // Common
    'common.loading': 'Yükleniyor...',
    'common.error': 'Bir hata oluştu',
    'common.success': 'Başarılı',
    'common.close': 'Kapat',
    'common.more': 'Daha Fazla',
  },
  
  en: {
    // Navigation
    'nav.home': 'Home',
    'nav.tours': 'Tours',
    'nav.istanbul': 'Istanbul Tours',
    'nav.domestic': 'Domestic Tours',
    'nav.international': 'International Tours',
    'nav.all_tours': 'View All Tours',
    'nav.blog': 'Istanbul Stories',
    'nav.about': 'About Us',
    'nav.contact': 'Contact',
    'nav.admin': 'Admin',
    
    // Homepage
    'home.hero_title': 'Discover Istanbul',
    'home.hero_subtitle': 'Experience the magic of the historic peninsula with our professional guides',
    'home.featured_tours': 'Featured Tours',
    'home.featured_subtitle': 'Experience the magic of Istanbul with our most popular and beloved tours',
    'home.upcoming_tours': 'Upcoming Tours',
    'home.view_all': 'View All',
    'home.calendar_title': 'Tour Calendar',
    'home.calendar_subtitle': 'Book your spot on available dates',
    'home.no_tours_this_month': 'No tours scheduled for this month.',
    'home.check_calendar': 'Check other months on the calendar.',
    'tour.info_request': "Ask about new dates",
    'home.istanbul_calendar': "Istanbul Tours Calendar",
    'home.upcoming_istanbul': "Upcoming Istanbul Tours",
    'tour.dates_section': "Tour Dates",
    'tour.next_date': 'NEXT TOUR',
    'tour.dates_soon': 'New dates coming soon',
    'tour.upcoming_dates': 'Upcoming Tour Dates',
    'tour.available': 'Available',
    'tour.limited': 'Last Seats',
    'tour.full': 'Full',
    'tour.related': 'You May Also Like',
    'tour.no_open_dates': 'There are currently no dates open for booking. New dates will be added soon.',
    'tour.pick_date_hint': 'Pick an open date from the list or the calendar.',
    'tour.seats_left': 'seats left',
    'tour.selected_date': 'Selected date',
    'home.day_tours': 'Tours on this day',
    'home.calendar_heading': 'Tour Calendar',
    'home.calendar_desc': 'See upcoming tours and book right away',
    'home.book': 'Book',
    'home.view_all_tours': 'View All Tours',
    'home.month_calendar': 'tour calendar',
    
    // Tours
    'tours.per_person': '/person',
    'tours.duration': 'Duration',
    'tours.capacity': 'Capacity',
    'tours.meeting_point': 'Meeting Point',
    'tours.included': 'Included',
    'tours.excluded': 'Not Included',
    'tours.program': 'Tour Program',
    'tours.book_now': 'Book Now',
    'tours.whatsapp': 'Ask via WhatsApp',
    'tours.day': 'Day',
    
    // Booking Form
    'booking.title': 'Booking Form',
    'booking.first_name': 'First Name',
    'booking.last_name': 'Last Name',
    'booking.tc_number': 'ID Number',
    'booking.birth_date': 'Birth Date',
    'booking.email': 'Email',
    'booking.phone': 'Phone',
    'booking.guests': 'Number of Guests',
    'booking.date': 'Select Date',
    'booking.payment_method': 'Payment Method',
    'booking.credit_card': 'Credit Card',
    'booking.bank_transfer': 'Bank Transfer',
    'booking.cash_on_tour': 'Pay on Tour',
    'booking.special_requests': 'Special Requests',
    'booking.submit': 'Book Now',
    'booking.total': 'Total',
    
    // Contact
    'contact.title': 'Contact',
    'contact.subtitle': 'Get in touch with us',
    'contact.working_hours': 'Working Hours',
    'contact.weekdays': 'Weekdays (Mon-Fri)',
    'contact.weekend': 'Weekend',
    'contact.closed': 'Closed',
    'contact.send': 'Send',
    
    // About
    'about.title': 'About Us',
    'about.who_we_are': 'Who We Are?',
    
    // Footer
    'footer.rights': 'All Rights Reserved',
    'footer.tursab': 'TÜRSAB Member',
    
    // Common
    'common.loading': 'Loading...',
    'common.error': 'An error occurred',
    'common.success': 'Success',
    'common.close': 'Close',
    'common.more': 'More',
  },
  
  ar: {
    // Navigation
    'nav.home': 'الرئيسية',
    'nav.tours': 'الجولات',
    'nav.istanbul': 'جولات إسطنبول',
    'nav.domestic': 'جولات داخلية',
    'nav.international': 'جولات دولية',
    'nav.all_tours': 'عرض جميع الجولات',
    'nav.blog': 'قصص إسطنبول',
    'nav.about': 'من نحن',
    'nav.contact': 'اتصل بنا',
    'nav.admin': 'لوحة التحكم',
    
    // Homepage
    'home.hero_title': 'اكتشف إسطنبول',
    'home.hero_subtitle': 'استمتع بسحر شبه الجزيرة التاريخية مع مرشدينا المحترفين',
    'home.featured_tours': 'جولات مميزة',
    'home.featured_subtitle': 'استمتع بسحر إسطنبول مع جولاتنا الأكثر شعبية ومحبوبة',
    'home.upcoming_tours': 'الجولات القادمة',
    'home.view_all': 'عرض الكل',
    'home.calendar_title': 'تقويم الجولات',
    'home.calendar_subtitle': 'احجز مكانك في التواريخ المتاحة',
    'home.no_tours_this_month': 'لا توجد جولات مجدولة لهذا الشهر.',
    'home.check_calendar': 'تحقق من الأشهر الأخرى في التقويم.',
    'tour.info_request': "اسأل عن مواعيد جديدة",
    'home.istanbul_calendar': "تقويم جولات إسطنبول",
    'home.upcoming_istanbul': "جولات إسطنبول القادمة",
    'tour.dates_section': "مواعيد الجولة",
    'tour.next_date': 'أقرب جولة',
    'tour.dates_soon': 'مواعيد جديدة قريبًا',
    'tour.upcoming_dates': 'مواعيد الجولات القادمة',
    'tour.available': 'متاح',
    'tour.limited': 'آخر المقاعد',
    'tour.full': 'ممتلئ',
    'tour.related': 'قد يعجبك أيضًا',
    'tour.no_open_dates': 'لا توجد حاليًا مواعيد متاحة للحجز. ستتم إضافة مواعيد جديدة قريبًا.',
    'tour.pick_date_hint': 'اختر موعدًا متاحًا من القائمة أو التقويم.',
    'tour.seats_left': 'مقاعد متبقية',
    'tour.selected_date': 'التاريخ المختار',
    'home.day_tours': 'جولات هذا اليوم',
    'home.calendar_heading': 'تقويم الجولات',
    'home.calendar_desc': 'اطلع على الجولات القادمة واحجز فورًا',
    'home.book': 'احجز',
    'home.view_all_tours': 'عرض كل الجولات',
    'home.month_calendar': 'تقويم الجولات',
    
    // Tours
    'tours.per_person': '/شخص',
    'tours.duration': 'المدة',
    'tours.capacity': 'السعة',
    'tours.meeting_point': 'نقطة الالتقاء',
    'tours.included': 'يشمل',
    'tours.excluded': 'لا يشمل',
    'tours.program': 'برنامج الجولة',
    'tours.book_now': 'احجز الآن',
    'tours.whatsapp': 'استفسر عبر واتساب',
    'tours.day': 'يوم',
    
    // Booking Form
    'booking.title': 'نموذج الحجز',
    'booking.first_name': 'الاسم الأول',
    'booking.last_name': 'اسم العائلة',
    'booking.tc_number': 'رقم الهوية',
    'booking.birth_date': 'تاريخ الميلاد',
    'booking.email': 'البريد الإلكتروني',
    'booking.phone': 'الهاتف',
    'booking.guests': 'عدد الأشخاص',
    'booking.date': 'اختر التاريخ',
    'booking.payment_method': 'طريقة الدفع',
    'booking.credit_card': 'بطاقة ائتمان',
    'booking.bank_transfer': 'تحويل بنكي',
    'booking.cash_on_tour': 'الدفع أثناء الجولة',
    'booking.special_requests': 'طلبات خاصة',
    'booking.submit': 'احجز الآن',
    'booking.total': 'المجموع',
    
    // Contact
    'contact.title': 'اتصل بنا',
    'contact.subtitle': 'تواصل معنا',
    'contact.working_hours': 'ساعات العمل',
    'contact.weekdays': 'أيام الأسبوع (الإثنين-الجمعة)',
    'contact.weekend': 'نهاية الأسبوع',
    'contact.closed': 'مغلق',
    'contact.send': 'إرسال',
    
    // About
    'about.title': 'من نحن',
    'about.who_we_are': 'من نحن؟',
    
    // Footer
    'footer.rights': 'جميع الحقوق محفوظة',
    'footer.tursab': 'عضو TÜRSAB',
    
    // Common
    'common.loading': 'جارٍ التحميل...',
    'common.error': 'حدث خطأ',
    'common.success': 'نجاح',
    'common.close': 'إغلاق',
    'common.more': 'المزيد',
  },

  // German (Deutsch)
  de: {
    // Navigation
    'nav.home': 'Startseite',
    'nav.tours': 'Touren',
    'nav.istanbul': 'Istanbul Touren',
    'nav.domestic': 'Inlandstouren',
    'nav.international': 'Auslandstouren',
    'nav.all_tours': 'Alle Touren anzeigen',
    'nav.blog': 'Istanbul Geschichten',
    'nav.about': 'Über uns',
    'nav.contact': 'Kontakt',
    'nav.admin': 'Verwaltung',
    
    // Homepage
    'home.hero_title': 'Entdecken Sie Istanbul',
    'home.hero_subtitle': 'Erleben Sie die Magie der historischen Halbinsel mit unseren professionellen Reiseleitern',
    'home.featured_tours': 'Ausgewählte Touren',
    'home.featured_subtitle': 'Erleben Sie den Zauber Istanbuls mit unseren beliebtesten Touren',
    'home.upcoming_tours': 'Kommende Touren',
    'home.view_all': 'Alle anzeigen',
    'home.calendar_title': 'Tourenkalender',
    'home.calendar_subtitle': 'Buchen Sie Ihren Platz an verfügbaren Terminen',
    'home.no_tours_this_month': 'Für diesen Monat sind keine Touren geplant.',
    'home.check_calendar': 'Überprüfen Sie andere Monate im Kalender.',
    'tour.info_request': "Nach neuen Terminen fragen",
    'home.istanbul_calendar': "Kalender der Istanbul-Touren",
    'home.upcoming_istanbul': "Kommende Istanbul-Touren",
    'tour.dates_section': "Tourtermine",
    'tour.next_date': 'NÄCHSTE TOUR',
    'tour.dates_soon': 'Neue Termine folgen bald',
    'tour.upcoming_dates': 'Kommende Tourtermine',
    'tour.available': 'Verfügbar',
    'tour.limited': 'Letzte Plätze',
    'tour.full': 'Ausgebucht',
    'tour.related': 'Das könnte Ihnen auch gefallen',
    'tour.no_open_dates': 'Derzeit sind keine buchbaren Termine verfügbar. Neue Termine folgen bald.',
    'tour.pick_date_hint': 'Wählen Sie einen offenen Termin aus der Liste oder dem Kalender.',
    'tour.seats_left': 'Plätze frei',
    'tour.selected_date': 'Gewähltes Datum',
    'home.day_tours': 'Touren an diesem Tag',
    'home.calendar_heading': 'Tourkalender',
    'home.calendar_desc': 'Kommende Touren ansehen und sofort buchen',
    'home.book': 'Buchen',
    'home.view_all_tours': 'Alle Touren ansehen',
    'home.month_calendar': 'Tourkalender',
    
    // Tours
    'tours.per_person': '/Person',
    'tours.duration': 'Dauer',
    'tours.capacity': 'Kapazität',
    'tours.meeting_point': 'Treffpunkt',
    'tours.included': 'Inklusive',
    'tours.excluded': 'Nicht inklusive',
    'tours.program': 'Tourprogramm',
    'tours.book_now': 'Jetzt buchen',
    'tours.whatsapp': 'Per WhatsApp anfragen',
    'tours.day': 'Tag',
    
    // Booking Form
    'booking.title': 'Buchungsformular',
    'booking.first_name': 'Vorname',
    'booking.last_name': 'Nachname',
    'booking.tc_number': 'Ausweisnummer',
    'booking.birth_date': 'Geburtsdatum',
    'booking.email': 'E-Mail',
    'booking.phone': 'Telefon',
    'booking.guests': 'Anzahl der Gäste',
    'booking.date': 'Datum wählen',
    'booking.payment_method': 'Zahlungsmethode',
    'booking.credit_card': 'Kreditkarte',
    'booking.bank_transfer': 'Banküberweisung',
    'booking.cash_on_tour': 'Zahlung vor Ort',
    'booking.special_requests': 'Besondere Wünsche',
    'booking.submit': 'Jetzt buchen',
    'booking.total': 'Gesamt',
    
    // Contact
    'contact.title': 'Kontakt',
    'contact.subtitle': 'Kontaktieren Sie uns',
    'contact.working_hours': 'Öffnungszeiten',
    'contact.weekdays': 'Wochentags (Mo-Fr)',
    'contact.weekend': 'Wochenende',
    'contact.closed': 'Geschlossen',
    'contact.send': 'Senden',
    
    // About
    'about.title': 'Über uns',
    'about.who_we_are': 'Wer sind wir?',
    
    // Footer
    'footer.rights': 'Alle Rechte vorbehalten',
    'footer.tursab': 'TÜRSAB Mitglied',
    
    // Common
    'common.loading': 'Wird geladen...',
    'common.error': 'Ein Fehler ist aufgetreten',
    'common.success': 'Erfolgreich',
    'common.close': 'Schließen',
    'common.more': 'Mehr',
  },

  // Spanish (Español)
  es: {
    // Navigation
    'nav.home': 'Inicio',
    'nav.tours': 'Tours',
    'nav.istanbul': 'Tours de Estambul',
    'nav.domestic': 'Tours Nacionales',
    'nav.international': 'Tours Internacionales',
    'nav.all_tours': 'Ver todos los tours',
    'nav.blog': 'Historias de Estambul',
    'nav.about': 'Sobre nosotros',
    'nav.contact': 'Contacto',
    'nav.admin': 'Administración',
    
    // Homepage
    'home.hero_title': 'Descubre Estambul',
    'home.hero_subtitle': 'Vive la magia de la península histórica con nuestros guías profesionales',
    'home.featured_tours': 'Tours Destacados',
    'home.featured_subtitle': 'Vive la magia de Estambul con nuestros tours más populares y queridos',
    'home.upcoming_tours': 'Próximos Tours',
    'home.view_all': 'Ver todo',
    'home.calendar_title': 'Calendario de Tours',
    'home.calendar_subtitle': 'Reserva tu lugar en las fechas disponibles',
    'home.no_tours_this_month': 'No hay tours programados para este mes.',
    'home.check_calendar': 'Consulta otros meses en el calendario.',
    'tour.info_request': "Consultar nuevas fechas",
    'home.istanbul_calendar': "Calendario de tours por Estambul",
    'home.upcoming_istanbul': "Próximos tours por Estambul",
    'tour.dates_section': "Fechas del tour",
    'tour.next_date': 'PRÓXIMO TOUR',
    'tour.dates_soon': 'Nuevas fechas próximamente',
    'tour.upcoming_dates': 'Próximas fechas del tour',
    'tour.available': 'Disponible',
    'tour.limited': 'Últimas plazas',
    'tour.full': 'Completo',
    'tour.related': 'También te puede gustar',
    'tour.no_open_dates': 'Actualmente no hay fechas abiertas para reservar. Pronto se añadirán nuevas fechas.',
    'tour.pick_date_hint': 'Elige una fecha disponible de la lista o del calendario.',
    'tour.seats_left': 'plazas libres',
    'tour.selected_date': 'Fecha seleccionada',
    'home.day_tours': 'Tours de este día',
    'home.calendar_heading': 'Calendario de tours',
    'home.calendar_desc': 'Consulta los próximos tours y reserva al instante',
    'home.book': 'Reservar',
    'home.view_all_tours': 'Ver todos los tours',
    'home.month_calendar': 'calendario de tours',
    
    // Tours
    'tours.per_person': '/persona',
    'tours.duration': 'Duración',
    'tours.capacity': 'Capacidad',
    'tours.meeting_point': 'Punto de encuentro',
    'tours.included': 'Incluido',
    'tours.excluded': 'No incluido',
    'tours.program': 'Programa del tour',
    'tours.book_now': 'Reservar ahora',
    'tours.whatsapp': 'Preguntar por WhatsApp',
    'tours.day': 'Día',
    
    // Booking Form
    'booking.title': 'Formulario de reserva',
    'booking.first_name': 'Nombre',
    'booking.last_name': 'Apellido',
    'booking.tc_number': 'Número de identificación',
    'booking.birth_date': 'Fecha de nacimiento',
    'booking.email': 'Correo electrónico',
    'booking.phone': 'Teléfono',
    'booking.guests': 'Número de huéspedes',
    'booking.date': 'Seleccionar fecha',
    'booking.payment_method': 'Método de pago',
    'booking.credit_card': 'Tarjeta de crédito',
    'booking.bank_transfer': 'Transferencia bancaria',
    'booking.cash_on_tour': 'Pago en el tour',
    'booking.special_requests': 'Solicitudes especiales',
    'booking.submit': 'Reservar ahora',
    'booking.total': 'Total',
    
    // Contact
    'contact.title': 'Contacto',
    'contact.subtitle': 'Contáctenos',
    'contact.working_hours': 'Horario de atención',
    'contact.weekdays': 'Días laborables (Lun-Vie)',
    'contact.weekend': 'Fin de semana',
    'contact.closed': 'Cerrado',
    'contact.send': 'Enviar',
    
    // About
    'about.title': 'Sobre nosotros',
    'about.who_we_are': '¿Quiénes somos?',
    
    // Footer
    'footer.rights': 'Todos los derechos reservados',
    'footer.tursab': 'Miembro de TÜRSAB',
    
    // Common
    'common.loading': 'Cargando...',
    'common.error': 'Ocurrió un error',
    'common.success': 'Éxito',
    'common.close': 'Cerrar',
    'common.more': 'Más',
  },

  // Chinese (中文)
  zh: {
    // Navigation
    'nav.home': '首页',
    'nav.tours': '旅游',
    'nav.istanbul': '伊斯坦布尔之旅',
    'nav.domestic': '国内游',
    'nav.international': '国际游',
    'nav.all_tours': '查看所有旅游',
    'nav.blog': '伊斯坦布尔故事',
    'nav.about': '关于我们',
    'nav.contact': '联系我们',
    'nav.admin': '管理',
    
    // Homepage
    'home.hero_title': '探索伊斯坦布尔',
    'home.hero_subtitle': '与我们的专业导游一起体验历史半岛的魅力',
    'home.featured_tours': '精选旅游',
    'home.featured_subtitle': '通过我们最受欢迎和喜爱的旅游体验伊斯坦布尔的魅力',
    'home.upcoming_tours': '即将到来的旅游',
    'home.view_all': '查看全部',
    'home.calendar_title': '旅游日历',
    'home.calendar_subtitle': '在可用日期预订您的位置',
    'home.no_tours_this_month': '本月没有安排旅游。',
    'home.check_calendar': '请查看日历上的其他月份。',
    'tour.info_request': "咨询新日期",
    'home.istanbul_calendar': "伊斯坦布尔旅游日历",
    'home.upcoming_istanbul': "即将出发的伊斯坦布尔旅游",
    'tour.dates_section': "出发日期",
    'tour.next_date': '最近出发',
    'tour.dates_soon': '新日期即将公布',
    'tour.upcoming_dates': '即将出发日期',
    'tour.available': '可预订',
    'tour.limited': '名额紧张',
    'tour.full': '已满',
    'tour.related': '您可能还喜欢',
    'tour.no_open_dates': '目前没有可预订的日期，新日期即将添加。',
    'tour.pick_date_hint': '请从列表或日历中选择可预订的日期。',
    'tour.seats_left': '个剩余名额',
    'tour.selected_date': '已选日期',
    'home.day_tours': '当天的旅游',
    'home.calendar_heading': '旅游日历',
    'home.calendar_desc': '查看即将出发的旅游并立即预订',
    'home.book': '预订',
    'home.view_all_tours': '查看所有旅游',
    'home.month_calendar': '旅游日历',
    
    // Tours
    'tours.per_person': '/人',
    'tours.duration': '时长',
    'tours.capacity': '容量',
    'tours.meeting_point': '集合地点',
    'tours.included': '包含',
    'tours.excluded': '不包含',
    'tours.program': '行程安排',
    'tours.book_now': '立即预订',
    'tours.whatsapp': '通过WhatsApp咨询',
    'tours.day': '天',
    
    // Booking Form
    'booking.title': '预订表格',
    'booking.first_name': '名',
    'booking.last_name': '姓',
    'booking.tc_number': '身份证号',
    'booking.birth_date': '出生日期',
    'booking.email': '电子邮箱',
    'booking.phone': '电话',
    'booking.guests': '人数',
    'booking.date': '选择日期',
    'booking.payment_method': '支付方式',
    'booking.credit_card': '信用卡',
    'booking.bank_transfer': '银行转账',
    'booking.cash_on_tour': '现场支付',
    'booking.special_requests': '特殊要求',
    'booking.submit': '立即预订',
    'booking.total': '总计',
    
    // Contact
    'contact.title': '联系我们',
    'contact.subtitle': '与我们取得联系',
    'contact.working_hours': '工作时间',
    'contact.weekdays': '工作日（周一至周五）',
    'contact.weekend': '周末',
    'contact.closed': '休息',
    'contact.send': '发送',
    
    // About
    'about.title': '关于我们',
    'about.who_we_are': '我们是谁？',
    
    // Footer
    'footer.rights': '版权所有',
    'footer.tursab': 'TÜRSAB会员',
    
    // Common
    'common.loading': '加载中...',
    'common.error': '发生错误',
    'common.success': '成功',
    'common.close': '关闭',
    'common.more': '更多',
  }
};

// Language names for display
const languageNames = {
  tr: { name: 'Türkçe', flag: '🇹🇷', dir: 'ltr' },
  en: { name: 'English', flag: '🇬🇧', dir: 'ltr' },
  de: { name: 'Deutsch', flag: '🇩🇪', dir: 'ltr' },
  es: { name: 'Español', flag: '🇪🇸', dir: 'ltr' },
  zh: { name: '中文', flag: '🇨🇳', dir: 'ltr' },
  ar: { name: 'العربية', flag: '🇸🇦', dir: 'rtl' }
};

// Create context
const LanguageContext = createContext();

// Provider component
export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    // Check localStorage first
    const saved = localStorage.getItem('language');
    if (saved && translations[saved]) return saved;
    
    return 'tr'; // Default to Turkish
  });

  useEffect(() => {
    localStorage.setItem('language', language);
    // Update document direction for RTL languages
    document.documentElement.dir = languageNames[language]?.dir || 'ltr';
    document.documentElement.lang = language;
  }, [language]);

  // Translation function
  const t = (key) => {
    return translations[language]?.[key] || translations['tr']?.[key] || key;
  };

  // Change language
  const changeLanguage = (newLang) => {
    if (translations[newLang]) {
      setLanguage(newLang);
    }
  };

  const value = {
    language,
    changeLanguage,
    t,
    languages: Object.keys(translations),
    languageInfo: languageNames[language],
    allLanguages: languageNames
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

// Hook for using language context
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}

// Language Selector Component
export function LanguageSelector({ className = '' }) {
  const { language, changeLanguage, allLanguages } = useLanguage();
  
  return (
    <div className={`relative inline-block ${className}`}>
      <select
        value={language}
        onChange={(e) => changeLanguage(e.target.value)}
        className="appearance-none bg-transparent border border-gray-300 rounded-lg px-3 py-2 pr-8 text-sm font-medium cursor-pointer hover:border-orange-500 focus:outline-none focus:ring-2 focus:ring-orange-500"
        data-testid="language-selector"
      >
        {Object.entries(allLanguages).map(([code, info]) => (
          <option key={code} value={code}>
            {info.flag} {info.name}
          </option>
        ))}
      </select>
      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500">
        <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </div>
    </div>
  );
}

export default translations;
